import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // this.element.addEventListener('turbo:submit-end', this.hideModal);
    greenPOS.initSemanticModal();
    $(this.element).modal("show");
  }
};
